/* ============================================================
   COLD SCHOOL — Chicago to Seal Beach drop engine
   Reads window.CSB (injected by snippets/csb-config.liquid) and
   wires the tee + jersey/shorts set cards to Shopify's AJAX cart.
   Prices from Shopify are in CENTS.
   ============================================================ */
(function(){
  var CSB = window.CSB || {};
  if(!document.getElementById('csb-anton-font')){var fl=document.createElement('link');fl.id='csb-anton-font';fl.rel='stylesheet';fl.href='https://fonts.googleapis.com/css2?family=Anton&display=swap';document.head.appendChild(fl);}
  var root = document.querySelector('.csb-root');
  if(!root) return;
  var $ = function(s){return root.querySelector(s);};
  var $$ = function(s){return Array.prototype.slice.call(root.querySelectorAll(s));};
  var money = function(c){var n=c/100;return '$'+(n%1===0?n.toFixed(0):n.toFixed(2));};

  /* toast */
  var toastEl=document.createElement('div');toastEl.className='csb-toast';document.body.appendChild(toastEl);
  var toastT;
  function toast(m){toastEl.textContent=m;toastEl.classList.add('show');clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('show');},2200);}

  /* ---------- COUNTDOWNS ---------- */
  function pad(n){return String(n).padStart(2,'0');}
  function tick(){
    var now=Date.now();
    [['tee',CSB.teeCloseISO],['jersey',CSB.jerseyCloseISO]].forEach(function(pair){
      var k=pair[0],iso=pair[1];var card=$('#csb-cc-'+k);if(!card||!iso)return;
      var clk=$('#csb-clk-'+k);if(!clk)return;var u=clk.children;
      var t=new Date(iso).getTime()-now;
      if(t<=0){card.classList.add('closed');[0,1,2,3].forEach(function(i){u[i].querySelector('b').textContent='00';});return;}
      var d=Math.floor(t/864e5),h=Math.floor(t%864e5/36e5),m=Math.floor(t%36e5/6e4),s=Math.floor(t%6e4/1e3);
      u[0].querySelector('b').textContent=pad(d);u[1].querySelector('b').textContent=pad(h);
      u[2].querySelector('b').textContent=pad(m);u[3].querySelector('b').textContent=pad(s);
    });
  }
  tick();setInterval(tick,1000);

  /* ---------- SHOPIFY CART ---------- */
  function cartAdd(id,qty,props,cb){
    if(!id){toast('That option is unavailable');return;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:id,quantity:qty||1,properties:props||{}})})
      .then(function(r){return r.json();})
      .then(function(res){ if(res.status){toast(res.description||'Could not add');return;}
        if(cb)cb(res);
        csbRefreshCart();
      })
      .catch(function(){toast('Network error — try again');});
  }

  function csbRefreshCart(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){document.querySelectorAll('[data-count]').forEach(function(el){el.setAttribute('data-count',cart.item_count);el.setAttribute('aria-label','Cart ('+cart.item_count+')');});}).catch(function(){});fetch('/cart?section_id=cart-drawer-contents').then(function(r){return r.text();}).then(function(html){var holder=document.querySelector('[data-cart-contents]');if(!holder)return;var tmp=document.createElement('div');tmp.innerHTML=html;var fresh=tmp.querySelector('[data-cart-contents]');if(fresh)holder.innerHTML=fresh.innerHTML;}).catch(function(){});}

  /* ---------- TEE ---------- */
  var tee = CSB.tee || {variants:[],images:[]};
  var teeSel=null;
  (function buildTee(){
    var wrap=$('#csb-tee-sizes');if(!wrap||!tee.variants)return;
    tee.variants.forEach(function(v){
      var b=document.createElement('button');b.className='csb-sz';b.dataset.id=v.id;
      b.disabled=!v.available;
      b.innerHTML=v.size+'<span class="tier">'+money(v.price)+(v.available?'':' · sold')+'</span>';
      b.onclick=function(){selTee(v,b);};wrap.appendChild(b);
    });
  })();
  function selTee(v,b){teeSel=v;$$('#csb-tee-sizes .csb-sz').forEach(function(x){x.classList.remove('sel');});b.classList.add('sel');
    var p=$('#csb-tee-price');if(p)p.textContent=money(v.price);
    var h=$('#csb-tee-hint');if(h)h.textContent=v.size+(v.tier?' · '+v.tier:'')+' — '+money(v.price)+'. Add each family member’s size one at a time.';}
  window.csbTeeView=function(which,el){var img=$('#csb-tee-img');if(img&&tee.images)img.src=(which==='back'?tee.images.back:tee.images.front)||img.src;
    var tag=$('#csb-tee-viewtag');if(tag)tag.textContent=which==='back'?'Back':'Front';
    $$('#csb-tee-thumbs .csb-thumb').forEach(function(t){t.classList.remove('sel');});if(el)el.classList.add('sel');};
  var teeAddBtn=$('#csb-tee-add');
  if(teeAddBtn)teeAddBtn.onclick=function(){
    if(!teeSel){toast('Pick a size first');return;}
    cartAdd(teeSel.id,1,{},function(){toast('Tee added — arrives before California');});
  };

  /* ---------- SET (jersey + shorts) ---------- */
  var set = CSB.set || {variants:[],images:{}};
  var sCw='black', sEd=(CSB.playerDefault!==false?'Player Edition':'Standard'), sSize=null, sView='jf';
  var editions = uniq(set.variants.map(function(v){return v.edition;}));
  var colorways = uniq(set.variants.map(function(v){return v.colorway;}));
  function uniq(a){var o=[];a.forEach(function(x){if(x&&o.indexOf(x)===-1)o.push(x);});return o;}
  if(colorways.length&&colorways.indexOf('Black')===-1)sCw=colorways[0].toLowerCase();

  function setImages(cw){return (set.images&&set.images[cw])||{};}
  function paintSet(){
    var imgs=setImages(sCw);
    var main=$('#csb-set-img');
    if(main&&imgs[sView])main.src=imgs[sView];
    ['jf','jb','sf','sb'].forEach(function(v){var t=$('#csb-tb-'+v);if(t&&imgs[v])t.src=imgs[v];});
    var tags={jf:'Jersey · Front',jb:'Jersey · Back',sf:'Shorts · Front',sb:'Shorts · Back'};
    var tag=$('#csb-set-viewtag');if(tag)tag.textContent=tags[sView]+' · '+(sCw==='black'?'Black':'White');
    updateOverlay();
  }
  window.csbSetCw=function(cw){sCw=cw;$$('#csb-cw button').forEach(function(b){b.classList.toggle('sel',b.dataset.cw===cw);});paintSet();};
  window.csbSetView=function(v,el){sView=v;$$('#csb-set-thumbs .csb-thumb').forEach(function(t){t.classList.remove('sel');});if(el)el.classList.add('sel');paintSet();};

  /* editions */
  (function buildEd(){
    var wrap=$('#csb-editions');if(!wrap)return;wrap.innerHTML='';
    var playerName=editions.filter(function(e){return /player/i.test(e);})[0]||'Player Edition';
    var stdName=editions.filter(function(e){return !/player/i.test(e);})[0]||'Standard';
    var order=[playerName,stdName];
    order.forEach(function(e){
      var isPlayer=/player/i.test(e);
      var pv=priceFor(e);
      var d=document.createElement('div');d.className='csb-ed'+((e===sEd)?' sel':'');d.dataset.ed=e;
      d.innerHTML=(isPlayer?'<span class="badge">Most pick this</span>':'')+
        '<div class="et"><span>'+e+'</span><span>'+(isPlayer?'+'+money(CSB.playerAddCents||1000):money(pv))+'</span></div>'+
        '<div class="ed-sub">'+(isPlayer?'Your last name &amp; number on the back.':'The #'+(CSB.defaultNumber||'26')+' collection design.')+'</div>';
      d.onclick=function(){window.csbSetEd(e);};wrap.appendChild(d);
    });
  })();
  function priceFor(ed){var v=set.variants.filter(function(x){return x.edition===ed;})[0];return v?v.price:(CSB.setStandardCents||6500);}
  window.csbSetEd=function(ed){sEd=ed;$$('#csb-editions .csb-ed').forEach(function(e){e.classList.toggle('sel',e.dataset.ed===ed);});
    var isPlayer=/player/i.test(ed);
    var np=$('#csb-np-block');if(np)np.style.display=isPlayer?'block':'none';
    var pr=$('#csb-set-price');if(pr)pr.textContent=money(priceFor(ed));
    cancelGate();updateOverlay();};

  /* sizes */
  (function buildSetSizes(){
    var wrap=$('#csb-set-sizes');if(!wrap)return;
    var sizes=uniq(set.variants.map(function(v){return v.size;}));
    sizes.forEach(function(sz){
      var b=document.createElement('button');b.className='csb-sz';b.dataset.size=sz;b.textContent=sz;
      b.onclick=function(){sSize=sz;$$('#csb-set-sizes .csb-sz').forEach(function(x){x.classList.remove('sel');});b.classList.add('sel');};
      wrap.appendChild(b);
    });
  })();

  /* live nameplate overlay */
  function updateOverlay(){
    var ov=$('#csb-np-overlay');if(!ov)return;
    var show=/player/i.test(sEd)&&sView==='jb';
    ov.classList.toggle('show',show);if(!show)return;
    var nm=(($('#csb-np-name')||{}).value||'').toUpperCase().slice(0,12);
    var num=(($('#csb-np-num')||{}).value||'').replace(/[^0-9]/g,'').slice(0,2)||(CSB.defaultNumber||'26');
    $('#csb-ov-name').textContent=nm||'LAST NAME';
    $('#csb-ov-num').textContent=num;
    var name=$('#csb-ov-name'),mask=$('#csb-ov-mask'),n=$('#csb-ov-num');
    if(sCw==='black'){name.style.color='#fff';mask.style.background='#0b0b0d';n.style.color='transparent';n.style.webkitTextStroke='2.5px #e0322f';}
    else{name.style.color='#111';mask.style.background='#f6f6f6';n.style.color='#111';n.style.webkitTextStroke='2px #e0322f';}
  }
  window.csbRenderJersey=function(){ if(sView!=='jb'){window.csbSetView('jb',$('#csb-set-thumbs .csb-thumb[data-view="jb"]'));} updateOverlay(); };

  /* variant match + add */
  function matchVariant(){
    return set.variants.filter(function(v){
      return v.colorway.toLowerCase()===sCw && v.edition===sEd && v.size===sSize;
    })[0];
  }
  function pushSet(){
    var v=matchVariant();
    if(!v){toast('That combination is unavailable');return;}
    var props={};
    if(/player/i.test(sEd)){
      props['Name']=(($('#csb-np-name')||{}).value||'').trim().toUpperCase();
      props['Number']=(($('#csb-np-num')||{}).value||(CSB.defaultNumber||'26')).trim();
    }
    cartAdd(v.id,1,props,function(){toast('Set added — see you in September');});
  }
  var setAddBtn=$('#csb-set-add');
  if(setAddBtn)setAddBtn.onclick=function(){
    if(!sSize){toast('Pick a set size first');return;}
    if(/player/i.test(sEd)){
      var nm=(($('#csb-np-name')||{}).value||'').trim();
      if(!nm){toast('Add the last name for the Player Edition');var el=$('#csb-np-name');if(el)el.focus();return;}
      var num=(($('#csb-np-num')||{}).value||(CSB.defaultNumber||'26')).trim();
      $('#csb-gate-echo').textContent=nm.toUpperCase()+' · #'+num;
      $('#csb-gate').classList.add('show');setAddBtn.style.display='none';return;
    }
    pushSet();
  };
  window.csbCancelGate=cancelGate;
  function cancelGate(){var g=$('#csb-gate');if(g)g.classList.remove('show');if(setAddBtn)setAddBtn.style.display='';}
  window.csbConfirmJersey=function(){cancelGate();pushSet();};

  /* FAQ accordion */
  $$('.csb-qa').forEach(function(d){
    var btn=d.querySelector('button'),ans=d.querySelector('.ans');
    if(!btn||!ans)return;
    btn.onclick=function(){var open=d.classList.toggle('open');ans.style.maxHeight=open?ans.scrollHeight+'px':0;};
  });

  /* init */
  window.csbSetEd(sEd);
  var numI=$('#csb-np-num');if(numI&&!numI.value)numI.value=CSB.defaultNumber||'26';
  paintSet();
/* Sticky Add to Cart bar */
(function(){
if(!teeAddBtn&&!setAddBtn)return;
var bar=document.createElement("div");
bar.className="csb-sticky";
bar.setAttribute("aria-hidden","true");
bar.innerHTML='<div class="csb-sticky-inner"><img class="csb-sticky-thumb" alt=""><div class="csb-sticky-info"><div class="csb-sticky-name"></div><div class="csb-sticky-meta"></div></div><div class="csb-sticky-price"></div><button type="button" class="csb-btn csb-sticky-add"></button></div>';
document.body.appendChild(bar);
var thumbEl=bar.querySelector(".csb-sticky-thumb"),nameEl=bar.querySelector(".csb-sticky-name"),metaEl=bar.querySelector(".csb-sticky-meta"),priceEl=bar.querySelector(".csb-sticky-price"),addBtnEl=bar.querySelector(".csb-sticky-add");
var teeNameTxt=(($(".csb-card.tee .csb-name")||{}).textContent)||"Tee",setNameTxt=(($(".csb-card.jersey .csb-name")||{}).textContent)||"Jersey + Shorts Set";
var lastActive=null;
addBtnEl.onclick=function(){
var btn=lastActive==="tee"?teeAddBtn:(lastActive==="set"?setAddBtn:null);
if(!btn)return;
var card=btn.closest(".csb-card")||btn;
card.scrollIntoView({behavior:"smooth",block:"center"});
setTimeout(function(){btn.click();},450);
};
function computeActive(){
var vh=window.innerHeight||document.documentElement.clientHeight;
var tR=teeAddBtn?teeAddBtn.getBoundingClientRect():null;
var sR=setAddBtn?setAddBtn.getBoundingClientRect():null;
var teeButtonVisible=tR&&tR.bottom>0&&tR.top<vh;
var setButtonVisible=sR&&sR.bottom>0&&sR.top<vh;
var scrolledPastTee=tR&&tR.bottom<=0;
var scrolledPastSet=sR&&sR.bottom<=0;
var beforeSet=!sR||sR.top>=vh;
if(scrolledPastSet)return"set";
if(setButtonVisible)return null;
if(scrolledPastTee&&beforeSet)return"tee";
if(teeButtonVisible)return null;
return null;
}
function refresh(){
var active=computeActive();
lastActive=active;
if(!active){bar.classList.remove("show");bar.setAttribute("aria-hidden","true");return}
bar.classList.add("show");
bar.setAttribute("aria-hidden","false");
if(active==="tee"){
var img=$("#csb-tee-img");
thumbEl.src=img?img.src:"";
nameEl.textContent=teeNameTxt;
metaEl.textContent=teeSel?("Size "+teeSel.size):"Select a size";
priceEl.textContent=teeSel?money(teeSel.price):"";
addBtnEl.className="csb-btn orange csb-sticky-add";
addBtnEl.textContent="Add to cart";
}else{
var simg=$("#csb-set-img");
thumbEl.src=simg?simg.src:"";
nameEl.textContent=setNameTxt;
var metaParts=[sEd,sCw==="black"?"Black":"White"];
if(sSize)metaParts.push(sSize);
metaEl.textContent=metaParts.join(" \u00b7 ");
priceEl.textContent=money(priceFor(sEd));
addBtnEl.className="csb-btn blue csb-sticky-add";
addBtnEl.textContent="Add to cart";
}
}
var ticking=false;
function onScroll(){if(ticking)return;ticking=true;requestAnimationFrame(function(){refresh();ticking=false})}
window.addEventListener("scroll",onScroll,{passive:true});
window.addEventListener("resize",onScroll);
root.addEventListener("click",function(){setTimeout(refresh,0)});
root.addEventListener("input",function(){setTimeout(refresh,0)});
refresh();
})();
})();
